<template>
    <section id="education" class="education-component page-section">
        <div class="container">
            <header class="main-title title">Education</header>
            <div class="education-card">
                <button class="diploma" type="button" aria-label="Enlarge diploma" @click="openDiploma">
                    <img alt="B.Sc. diploma, Holon Institute of Technology" src="@/assets/education/degree.jpg">
                    <span class="enlarge">Click to enlarge</span>
                </button>
                <div class="details">
                    <h2 class="degree">B.Sc., Computer Science</h2>
                    <div class="institution">Holon Institute of Technology (HIT)</div>
                    <div class="period">2009 - 2013</div>
                    <dl class="courses">
                        <div v-for="course in courses" :key="course.label" class="course">
                            <dt>{{ course.label }}</dt>
                            <dd>{{ course.items }}</dd>
                        </div>
                    </dl>
                    <a href="/CV/Grades.pdf" class="download" download="Grades-Alexander Gorbatovsky">Download grades</a>
                </div>
            </div>
        </div>
        <div v-if="isDiplomaOpen" class="lightbox" role="dialog" aria-modal="true" aria-label="Diploma"
             @click="closeDiploma">
            <img class="lightbox-image" alt="B.Sc. diploma, Holon Institute of Technology"
                 src="@/assets/education/degree.jpg">
            <button ref="closeButton" class="close-button" type="button" aria-label="Close" @click.stop="closeDiploma">
                <font-awesome-icon :icon="['fas', 'times']"/>
            </button>
        </div>
    </section>
</template>

<script>
    export default {
        name: "EducationComponent",
        data() {
            return {
                isDiplomaOpen: false,
                courses: [
                    {label: 'Web programming', items: 'JavaScript, HTML, CSS, MySQL'},
                    {label: 'Mobile programming', items: 'Android, jQuery Mobile'},
                    {label: 'Programming', items: 'C / C++ / C#.NET, Java / J2EE, Scala'}
                ]
            };
        },
        mounted() {
            document.addEventListener('keydown', this.onKeydown);
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.onKeydown);
            this.unlockScroll();
        },
        methods: {
            openDiploma() {
                this.isDiplomaOpen = true;
                document.body.style.overflow = 'hidden';
                this.$nextTick(() => {
                    if (this.$refs.closeButton) {
                        this.$refs.closeButton.focus();
                    }
                });
            },
            closeDiploma() {
                this.isDiplomaOpen = false;
                this.unlockScroll();
            },
            unlockScroll() {
                document.body.style.overflow = 'auto';
            },
            onKeydown(event) {
                if (event.key === 'Escape' && this.isDiplomaOpen) {
                    this.closeDiploma();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #education.education-component {
        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            max-width: 1000px;
            margin: 0 auto;

            .title {
                margin-bottom: var(--section-title-gap, 50px);
            }

            .education-card {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 56px;
                width: 100%;

                .diploma {
                    position: relative;
                    flex: none;
                    width: 440px;
                    max-width: 100%;
                    padding: 0;
                    overflow: hidden;
                    background: #fff;
                    border: 2px solid #e9ecef;
                    border-radius: 8px;
                    box-shadow: 0 10px 28px -12px rgba(44, 62, 80, .5);
                    cursor: zoom-in;
                    transition: border-color .25s ease, box-shadow .25s ease;

                    img {
                        display: block;
                        width: 100%;
                        height: auto;
                    }

                    .enlarge {
                        position: absolute;
                        right: 10px;
                        bottom: 10px;
                        padding: 4px 12px;
                        font-size: 0.85em;
                        color: #fff;
                        background: rgba(44, 62, 80, .85);
                        border-radius: 999px;
                        opacity: 0;
                        transition: opacity .25s ease;
                    }

                    &:hover, &:focus-visible {
                        border-color: #2c3e50;
                        box-shadow: 0 14px 30px -10px rgba(44, 62, 80, .6);
                        outline: none;

                        .enlarge {
                            opacity: 1;
                        }
                    }
                }

                .details {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    min-width: 0;

                    .degree {
                        margin: 0;
                        font-size: 1.5em;
                        color: #2c3e50;
                    }

                    .institution {
                        margin-top: 6px;
                        font-weight: bold;
                    }

                    .period {
                        margin-top: 2px;
                        color: #979a9c;
                    }

                    .courses {
                        width: 100%;
                        margin: 22px 0;
                        border-top: 2px solid #e9ecef;

                        .course {
                            padding: 10px 0;
                            border-bottom: 2px solid #e9ecef;

                            dt {
                                font-weight: bold;
                                color: #2c3e50;
                            }

                            dd {
                                margin: 2px 0 0;
                                color: #555;
                            }
                        }
                    }
                }
            }
        }

        .lightbox {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1200;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 24px;
            background: rgba(37, 36, 44, .88);
            cursor: zoom-out;

            .lightbox-image {
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                background: #fff;
                border-radius: 4px;
                box-shadow: 0 20px 60px rgba(0, 0, 0, .5);
            }

            .close-button {
                position: absolute;
                top: 16px;
                right: 16px;
                width: 44px;
                height: 44px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
                font-size: 1.2em;
                color: #2c3e50;
                background: #fff;
                border: 2px solid #e9ecef;
                border-radius: 50%;
                cursor: pointer;

                &:hover, &:focus-visible {
                    background: #e9ecef;
                    border-color: #2c3e50;
                    outline: none;
                }
            }
        }
    }

    /*media*/
    @media screen and (max-width: 900px) {
        #education.education-component {
            .container {
                .education-card {
                    flex-direction: column;
                    gap: 28px;

                    .diploma {
                        width: min(440px, 100%);
                    }

                    .details {
                        width: 100%;
                        align-items: flex-start;
                    }
                }
            }
        }
    }
</style>
